import React, { Component } from "react";
import { View, TextInput, Dimensions, PixelRatio } from "react-native";
import { colors } from "@constants/theme";
const { width, height } = Dimensions.get("window");
const scale = width / 360;

function normalize(size) {
  const newSize = size * scale;
  return Math.round(PixelRatio.roundToNearestPixel(newSize));
}

const CustomInput = ({
  height,
  width,
  contentContainerStyle,
  value,
  onChange,
}) => {
  return (
    <View
      style={[
        {
          borderWidth: 1,
          borderColor: "rgba(0,0,0,0.2)",
          borderRadius: 4,
          width: width,
          height: height,
        },
        contentContainerStyle,
      ]}
    >
      <TextInput
        multiline
        value={value}
        onChangeText={onChange}
        placeholder="यहाँ लिखें..."
        style={{
          fontSize: normalize(14),
          padding: normalize(10),
          color: colors.mediumBlack,
        }}
      />
    </View>
  );
};

export default CustomInput;
